import produce from 'immer';
import { ReducerActionRotaSP } from 'store/modules/types';

// TYPES
import { Types, ExcluirFuncionalidadesRelacionadasLocalidade } from './types';

export const INITIAL_STATE: ExcluirFuncionalidadesRelacionadasLocalidade = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): ExcluirFuncionalidadesRelacionadasLocalidade {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EXCLUIR_FUNCIONALIDADES_RELACIONADAS_LOCALIDADE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.EXCLUIR_FUNCIONALIDADES_RELACIONADAS_LOCALIDADE_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.EXCLUIR_FUNCIONALIDADES_RELACIONADAS_LOCALIDADE_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.EXCLUIR_FUNCIONALIDADES_RELACIONADAS_LOCALIDADE_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
